/* Atipiná — Cart Newsletter CTA (10% off na 1ª compra) v18
   v18 (2026-07-30, Alex): FIX do travamento ao enviar o e-mail — o observer agora é
   debounced e PAUSA enquanto nós mesmos mexemos no DOM (loop com o app da calculadora
   de frete); guardas de contenção impedem HierarchyRequestError no reorder.
   v17: 'válido para a primeira compra' no card. v16: fix de timing do refresh.
   v15: card de sucesso permanente. v14: linha no resumo. */
(function(){
  'use strict';

  var KLAVIYO_COMPANY_ID = 'TBqNEx';
  var KLAVIYO_LIST_ID = 'TE34Rq';
  var KLAVIYO_REVISION = '2024-10-15';
  var DISCOUNT_CODE = 'PRIMEIRAAVENTURA';
  var STORAGE_KEY = 'atipina_welcome_discount_applied';
  var SIGNUP_KEY = 'atipina_newsletter_signed';

  var observer = null;
  var observerTarget = null;
  var pauseDepth = 0;

  function pausedWrite(fn){
    pauseDepth++;
    if (observer) observer.disconnect();
    try { fn(); } catch(e) { console.warn('[Atipiná] pausedWrite:', e); }
    pauseDepth--;
    if (observer && observerTarget && pauseDepth === 0) {
      observer.observe(observerTarget, { childList: true, subtree: true });
    }
  }

  function knownEmail(){
    if (window.AtipinaEmail && window.AtipinaEmail.get) {
      var id = window.AtipinaEmail.get();
      if (id && id.email) return id.email;
    }
    return '';
  }
  function maskEmail(email){
    if (window.AtipinaEmail && window.AtipinaEmail.mask) return window.AtipinaEmail.mask(email);
    return email;
  }

  function isSignedUp(){
    try { if (localStorage.getItem(SIGNUP_KEY) === '1') return true; } catch(e) {}
    try { if (sessionStorage.getItem(STORAGE_KEY) === '1') return true; } catch(e) {}
    return false;
  }

  function shouldShow(){
    if (window.__atipinaCustomerHasOrders === true) return false;
    if (window.__atipinaCartHasDiscount === true) return false;
    if (isSignedUp()) return false;
    return true;
  }

  function markSignedUpPersistent(){
    try { localStorage.setItem(SIGNUP_KEY, '1'); } catch(e) {}
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch(e) {}
  }

  function isValidEmail(email){
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function summaryShowsDiscount(){
    var holder = document.querySelector('[data-cart-page] .cart__price__holder');
    return !!(holder && holder.textContent.indexOf(DISCOUNT_CODE) !== -1);
  }

  /* linha informativa — só quando o resumo ainda não mostra o desconto real */
  function renderCouponLine(){
    var holder = document.querySelector('[data-cart-page] .cart__price__holder');
    if (!holder) return;
    var existing = holder.querySelector('[data-atipina-coupon-line]');
    var show = isSignedUp() && window.__atipinaCustomerHasOrders !== true && !summaryShowsDiscount();
    if (!show) { if (existing) pausedWrite(function(){ existing.remove(); }); return; }
    if (existing) return;
    var line = document.createElement('div');
    line.setAttribute('data-atipina-coupon-line', '');
    line.style.cssText = 'display:flex;align-items:center;gap:6px;margin:8px 0 0;font-family:Poppins,sans-serif;font-size:12px;font-weight:500;color:#1a1d1f;line-height:1.4;';
    line.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px;flex-shrink:0;" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg><span>Cupom <strong>' + DISCOUNT_CODE + '</strong> (−10%) garantido — aplicado no checkout</span>';
    pausedWrite(function(){ holder.appendChild(line); });
  }

  /* card de sucesso no lugar do bloco */
  function showSuccessCard(wrap, email){
    pausedWrite(function(){
      wrap.innerHTML = ''
        + '<div role="status" style="display:flex;align-items:center;gap:12px;">'
        +   '<span style="flex-shrink:0;width:34px;height:34px;background:#1a1d1f;color:#cbe64d;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;">'
        +     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px;"><polyline points="20 6 9 17 4 12"/></svg>'
        +   '</span>'
        +   '<span style="display:flex;flex-direction:column;gap:2px;min-width:0;">'
        +     '<span style="font-size:12.5px;font-weight:800;color:#1a1d1f;letter-spacing:.05em;text-transform:uppercase;line-height:1.2;">Cupom ' + DISCOUNT_CODE + ' aplicado!</span>'
        +     '<span style="font-size:10.5px;color:#1a1d1f;opacity:.75;font-weight:500;line-height:1.3;">Desconto de 10% já no resumo do pedido • válido para a primeira compra' + (email ? ' — ' + maskEmail(email) : '') + '</span>'
        +   '</span>'
        + '</div>';
    });
  }

  function buildCTA(){
    var wrap = document.createElement('div');
    wrap.className = 'atipina-cart-newsletter';
    wrap.innerHTML = ''
      + '<button type="button" class="atipina-cart-newsletter__cta-btn" data-cta-toggle aria-expanded="false">'
      +   '<span class="atipina-cart-newsletter__cta-icon" aria-hidden="true">'
      +     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'
      +       '<polyline points="20 12 20 22 4 22 4 12"/>'
      +       '<rect x="2" y="7" width="20" height="5"/>'
      +       '<line x1="12" y1="22" x2="12" y2="7"/>'
      +       '<path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>'
      +       '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>'
      +     '</svg>'
      +   '</span>'
      +   '<span class="atipina-cart-newsletter__cta-text">'
      +     '<span class="atipina-cart-newsletter__cta-title">Ganhe 10% OFF na 1ª compra</span>'
      +     '<span class="atipina-cart-newsletter__cta-sub">Cadastre seu e-mail e seu cupom será aplicado automaticamente</span>'
      +   '</span>'
      +   '<svg class="atipina-cart-newsletter__cta-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>'
      + '</button>'
      + '<form class="atipina-cart-newsletter__form" data-cart-newsletter-form novalidate>'
      +   '<input type="email" class="atipina-cart-newsletter__input" placeholder="seu@email.com" aria-label="Email" data-cart-newsletter-email required autocomplete="email">'
      +   '<button type="submit" class="atipina-cart-newsletter__submit" data-cart-newsletter-submit>QUERO MEU CUPOM</button>'
      + '</form>'
      + '<div class="atipina-cart-newsletter__known" data-cnl-known style="display:none;">'
      +   '<button type="button" class="atipina-cart-newsletter__submit" data-cnl-apply style="width:100%;">APLICAR MEUS 10%</button>'
      +   '<div style="font-size:11.5px;color:#1a1d1f;text-align:center;margin-top:7px;line-height:1.4;">no seu e-mail <strong data-cnl-known-email></strong> · <button type="button" data-cnl-notyou style="background:none;border:0;color:#1a1d1f;text-decoration:underline;text-underline-offset:2px;font-weight:700;cursor:pointer;font-size:11.5px;padding:0;font-family:inherit;">não é você?</button></div>'
      + '</div>'
      + '<div class="atipina-cart-newsletter__feedback" data-cart-newsletter-feedback aria-live="polite"></div>';
    return wrap;
  }

  function softRefreshCartPrices(){
    return fetch('/cart', { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newPrice = doc.querySelector('.cart__price__holder');
        var oldPrice = document.querySelector('.cart__price__holder');
        if (newPrice && oldPrice) pausedWrite(function(){ oldPrice.innerHTML = newPrice.innerHTML; });
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function(r){ return r ? r.json() : null; })
      .then(function(cart){
        if (!cart) return;
        var count = cart.item_count || 0;
        document.querySelectorAll('[data-cart-count], .cart-count, .cart__count, .header__cart-count, .cart-link__bubble, .cart-link__bubble-num, [data-header-cart-count], .header__icon-count').forEach(function(el){
          el.textContent = count;
        });
      })
      .catch(function(err){ console.warn('[Atipiná] Soft cart refresh erro:', err); });
  }

  function subscribeKlaviyoDirect(email){
    var payload = { data: { type: 'subscription', attributes: {
      custom_source: 'Cart Newsletter CTA',
      profile: { data: { type: 'profile', attributes: { email: email } } }
    }, relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
      body: JSON.stringify(payload)
    }).then(function(resp){
      if (resp.status === 202 || resp.status === 200 || resp.status === 201 || resp.status === 204) return { ok: true };
      return resp.text().then(function(text){
        var detail = 'status ' + resp.status;
        try { var d = JSON.parse(text); if (d.errors && d.errors[0]) detail = (d.errors[0].detail || d.errors[0].title || detail); } catch(e){}
        throw new Error(detail);
      });
    });
  }

  function subscribeKlaviyoLearnq(email){
    return new Promise(function(resolve, reject){
      if (!window._learnq || typeof window._learnq.push !== 'function') return reject(new Error('_learnq não disponível'));
      try {
        window._learnq.push(['identify', { '$email': email, '$source': 'Cart Newsletter CTA' }]);
        resolve({ ok: true });
      } catch(e) { reject(e); }
    });
  }

  function applyDiscountAndRefresh(wrap, feedback, email){
    markSignedUpPersistent();
    if (email && window.AtipinaEmail && window.AtipinaEmail.set) window.AtipinaEmail.set(email);

    fetch('/discount/' + DISCOUNT_CODE, { method: 'GET', credentials: 'same-origin' })
      .catch(function(err){ console.warn('[Atipiná] Falha ao aplicar cupom direto:', err); })
      .then(function(){
        showSuccessCard(wrap, email);
        return new Promise(function(res){ setTimeout(res, 350); });
      })
      .then(function(){ return softRefreshCartPrices(); })
      .then(function(){
        renderCouponLine();
        setTimeout(function(){
          softRefreshCartPrices().then(renderCouponLine);
        }, 1800);
      });
  }

  function subscribeThenApply(email, wrap, feedback, busyBtn){
    if (busyBtn) { busyBtn.disabled = true; busyBtn.textContent = 'ENVIANDO…'; }
    subscribeKlaviyoDirect(email)
      .then(function(){ applyDiscountAndRefresh(wrap, feedback, email); })
      .catch(function(err){
        console.warn('[Atipiná] Subscribe direto falhou:', err && err.message);
        subscribeKlaviyoLearnq(email)
          .then(function(){ applyDiscountAndRefresh(wrap, feedback, email); })
          .catch(function(){ applyDiscountAndRefresh(wrap, feedback, email); });
      });
  }

  function wire(wrap){
    var toggleBtn = wrap.querySelector('[data-cta-toggle]');
    var form = wrap.querySelector('[data-cart-newsletter-form]');
    var emailInput = wrap.querySelector('[data-cart-newsletter-email]');
    var submitBtn = wrap.querySelector('[data-cart-newsletter-submit]');
    var feedback = wrap.querySelector('[data-cart-newsletter-feedback]');
    var knownBlock = wrap.querySelector('[data-cnl-known]');
    var applyBtn = wrap.querySelector('[data-cnl-apply]');
    var knownEmailEl = wrap.querySelector('[data-cnl-known-email]');
    var notYouBtn = wrap.querySelector('[data-cnl-notyou]');

    function applyMode(){
      var em = knownEmail();
      if (em) {
        if (form) form.style.display = 'none';
        if (knownBlock) knownBlock.style.display = 'block';
        if (knownEmailEl) knownEmailEl.textContent = maskEmail(em);
      } else {
        if (knownBlock) knownBlock.style.display = 'none';
        if (form) form.style.display = '';
      }
    }

    toggleBtn.addEventListener('click', function(){
      var isExpanded = wrap.classList.toggle('is-expanded');
      toggleBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      if (isExpanded) {
        applyMode();
        var em = knownEmail();
        if (!em) setTimeout(function(){ emailInput.focus(); }, 80);
      }
    });

    form.addEventListener('submit', function(e){
      e.preventDefault();
      var email = (emailInput.value || '').trim().toLowerCase();
      feedback.className = 'atipina-cart-newsletter__feedback';
      feedback.textContent = '';
      if (!isValidEmail(email)) {
        feedback.classList.add('is-error');
        feedback.textContent = 'Digite um email válido.';
        return;
      }
      subscribeThenApply(email, wrap, feedback, submitBtn);
    });

    if (applyBtn) applyBtn.addEventListener('click', function(){
      var email = knownEmail();
      if (!email) { applyMode(); return; }
      feedback.className = 'atipina-cart-newsletter__feedback';
      feedback.textContent = '';
      subscribeThenApply(email, wrap, feedback, applyBtn);
    });

    if (notYouBtn) notYouBtn.addEventListener('click', function(){
      if (window.AtipinaEmail && window.AtipinaEmail.clear) window.AtipinaEmail.clear();
      applyMode();
      if (emailInput) { emailInput.value = ''; setTimeout(function(){ emailInput.focus(); }, 60); }
    });
  }

  function inject(){
    if (!shouldShow()) return false;
    if (document.querySelector('.atipina-cart-newsletter')) return false;
    var cartRoot = document.querySelector('[data-cart-page]');
    if (!cartRoot) return false;
    var freeShipping = cartRoot.querySelector('.cart__message.free-shipping');
    if (!freeShipping) return false;
    var target = freeShipping.closest('.cart-block') || freeShipping;
    var parent = target.parentNode;
    if (!parent) return false;
    var cta = buildCTA();
    pausedWrite(function(){ parent.insertBefore(cta, target); });
    wire(cta);
    return true;
  }

  function reorderCartAside(){
    var aside = document.querySelector('[data-cart-page] .cart__aside');
    if (!aside) return;
    var priceHolder = aside.querySelector('.cart__price__holder');
    var shippingWidget = aside.querySelector('.cart__widget--shipping');
    if (!priceHolder || !shippingWidget) return;
    var shippingBlock = shippingWidget.closest('.cart-block');
    if (!shippingBlock) return;
    /* v18: guardas de contenção — nunca mover se um contém o outro */
    if (shippingBlock.contains(priceHolder) || priceHolder.contains(shippingBlock)) return;
    if (shippingBlock.parentNode !== aside || priceHolder.parentNode !== aside) return;
    if (shippingBlock.nextElementSibling === priceHolder) return;
    pausedWrite(function(){ aside.insertBefore(shippingBlock, priceHolder); });
  }

  function init(){
    inject();
    reorderCartAside();
    renderCouponLine();
    var cartRoot = document.querySelector('[data-cart-page]');
    if (!cartRoot) return;
    observerTarget = cartRoot;
    var scheduled = false;
    observer = new MutationObserver(function(){
      if (scheduled) return;
      scheduled = true;
      /* v18: debounce — uma passada por frame, nunca em loop */
      requestAnimationFrame(function(){
        scheduled = false;
        if (!document.querySelector('.atipina-cart-newsletter') && shouldShow()) inject();
        reorderCartAside();
        renderCouponLine();
      });
    });
    observer.observe(cartRoot, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
